import { createFileRoute } from "@tanstack/react-router";
import { GapSurchargeFormPage } from "@/features/contracts/gap-surcharge-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/doplaty-gap/$id")({
	component: GapSurchargeFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.doplaty-gap",
			location.pathname,
		);
	},
});
